import { formatPercent, MaterialSymbol, withStyles } from 'vopay';
import styles from './TierPips.module.scss';

const cn = withStyles(styles);

type TierPipsProps = {
  numTiers: number;
  tierLevel: number;
  percent: number;
  isPremium?: boolean;
};

export default function TierPips({ numTiers, tierLevel, percent, isPremium = false }: TierPipsProps) {
  return (
    <div className={cn('tierPips', isPremium ? 'premium' : 'standard')}>
      <div className={cn('pips')}>
        {Array.from({ length: numTiers }, (_, index) => (
          <div key={index} className={cn('pip', isPremium ? 'premium' : 'standard', index < tierLevel && 'active')} />
        ))}
      </div>

      <div className={cn('percent')}>
        {isPremium
          ? Intl.NumberFormat(undefined, {
              minimumFractionDigits: 2,
              maximumFractionDigits: 2,
            }).format(percent * 100)
          : formatPercent(percent)}
      </div>

      {isPremium && <MaterialSymbol icon="auto_graph" />}
    </div>
  );
}
